import React from 'react';
import { Link } from '@lessonnine/design-system.lib';

import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext';
import { trackGuiInteracted } from 'src/dataLayer/remoteData/babbelEventStream';

export default ({
  trackingId,
  href,
  ...props
}) => {
  const { locale, learnLanguageCode } = useRouteParamsContext();

  const trackClick = () => {
    if (!props.disabled) {
      trackGuiInteracted({
        locale,
        learnLanguageCode,
        guiElementName: trackingId
      });
    }
  };

  const handleClick = () => {
    trackClick();
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <Link
      {...props}
      href={href}
      onClick={handleClick}
    />
  );
};
